import React, { useEffect } from 'react';
import ResponsiveSidebar from '@Components/LeftSidebar';
import { Outlet, useNavigate } from 'react-router-dom';
import { alpha, styled } from '@mui/material/styles';
import { getOrganizationDetails, setOrgCountry } from '@Reducers/OrganizationSetup';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootStateType } from '@Store';
import { organizationSetupRoute } from '@Constants/route';
import { useOrgSetupStatus } from '@Hook/useOrgSetupStatus';
import Header from '@Components/Header';

const Home: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const { pickupPinCode } = useSelector((state: RootStateType) => state.getRates.formData);
  const { isBookNow_WithAuth } = useSelector((state: RootStateType) => state.getRates);

  const orgPublicData = useSelector((state: RootStateType) => state.orgSetup.organizationPublicData);
  const countriesObj = useSelector((state: RootStateType) => state.global.countriesObj);

  const { orgCurrentLevel } = useOrgSetupStatus();

  // redirect create shipment
  useEffect(() => {
    if (pickupPinCode && !isBookNow_WithAuth) {
      navigate('/shipment/create-single');
    }
  }, [pickupPinCode, isBookNow_WithAuth, navigate]);

  // set country
  useEffect(() => {
    if (!orgPublicData?._countryId) return;
    const country = countriesObj[orgPublicData._countryId];
    dispatch(setOrgCountry(country));
  }, [countriesObj, orgPublicData?._countryId, dispatch]);

  // fetch org details
  useEffect(() => {
    dispatch(getOrganizationDetails());
  }, [dispatch]);

  // org level routing
  useEffect(() => {
    if (orgCurrentLevel !== 'shipment-settings') {
      navigate(organizationSetupRoute[orgCurrentLevel]);
    }
  }, [orgCurrentLevel, navigate]);

  if (orgCurrentLevel !== 'shipment-settings') return <Outlet />;

  return (
    <Layout>
      <ResponsiveSidebar />
      <MainSection>
        <Header />
        <Content>
          <Outlet />
        </Content>
      </MainSection>
    </Layout>
  );
};

export default Home;

/* ================= STYLES ================= */

const Layout = styled('section')(() => ({
  display: 'flex',
  height: '100vh',
  overflow: 'hidden',
  padding: '10px',
  gap: '10px',
}));

const MainSection = styled('div')(() => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}));

const Content = styled('div')(({ theme }) => ({
  flex: 1,
  overflowY: 'auto',
  padding: '24px',
  borderRadius: '16px',

  backgroundColor: '#fff',

  border: `1px solid ${alpha(theme.palette.secondary.main, 0.08)}`,
  marginTop: '10px',
}));
